export enum EventType {
	globalSearchChange = 'ksys-global-search-change',	// Used when a search is fired from the Global Search app
	globalInputsChange = 'ksys-global-inputs-change',	// Used when the input values change on a Global Inputs app
	appInitialized = 'ksys-app-initialized',			// Used when an app is initialized
	paginationChange = 'ksys-on-pagination-change',     // Used when one of the pagination buttons has been clicked or one of the pagination dropdowns' value has changed
	updatePagination = 'ksys-update-pagination',        // Used when an app linked to the pagination app has updated
}